export enum CodeTypeEnum {
  CodeTypeRegister = 1, //验证码类型 注册
  CodeTypeUpdatePwd = 2, //修改密码 和忘记密码
  CodeTypeUpdateBank = 3, //绑定银行信息
  CodeTypeBind = 4, //验证码类型 绑定
  CodeTypeLogin = 5, // 验证码类型 登录
  CodeTypeWithdraw2FA = 6, // 提现2FA
}

export enum VerifyTypeEnum {
  VerifyTypePhone = 0, //手机
  VerifyTypeEmail = 1, //邮箱
}

export enum VerifyTypePopInfoEnum {
  normal = 0, //默认KYC验证
  face = 1, //人脸识别
}

export enum LoginTypeEnum {
  cpf = "1", //cpf
  email = "2", //邮箱
  phone = "3", //手机
}
